module.exports = __webpack_public_path__ + "static/media/take-challenge-image.aa199b2c.png";